import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import Cite from './index.js';

var currentVersion = function currentVersion() {
  return this.log.length;
};

var retrieveVersion = function retrieveVersion() {
  var versnum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  if (versnum <= 0 || versnum > this.currentVersion()) {
    return null;
  } else {
    var _this$log = _slicedToArray(this.log[versnum - 1], 2),
        data = _this$log[0],
        options = _this$log[1];

    var image = new Cite(JSON.parse(data), JSON.parse(options));
    image.log = this.log.slice(0, versnum);
    return image;
  }
};

var undo = function undo() {
  var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return this.retrieveVersion(this.currentVersion() - number);
};

var retrieveLastVersion = function retrieveLastVersion() {
  return this.retrieveVersion(this.currentVersion());
};

var save = function save() {
  this.log.push([JSON.stringify(this.data), JSON.stringify(this._options)]);
  return this;
};

export { currentVersion, retrieveVersion, retrieveLastVersion, undo, save };